export enum JutePosition {
  BEFORE_AND_AFTER_PATHLABEL = 'BEFORE_AND_AFTER_PATHLABEL',
  BEFORE_PATHLABEL = 'BEFORE_PATHLABEL',
  AFTER_PATHLABEL = 'AFTER_PATHLABEL',
  NO_PATHLABEL = 'NO_PATHLABEL'
}
